<template>
  <PropertySection
    title="レスラクとの連携"
    :button="buttonText"
    :hideButton="hideButton"
    :disabled="buttonDisabled"
    small
    @click="onClick"
  >
    <template #text>
      <div :class="['label', { synced: resrakuSyncStatus >= 3 }]">
        {{ resrakuSyncStatusLabel }}
      </div>
    </template>
    <template #descSlot>
      <div class="desc">
        <template v-if="resrakuSyncStatus > 0">
          連携を解除する場合や設定を変更する場合は、レスラク問い合わせ：050-1744-6639 受付時間 10 時～18
          時（土日、祝日、夏季・冬季休業日を除く） までご連絡ください。<br />
          <a href="#" @click.prevent.stop="displayAuthKey">ぐるなび認証キー確認</a>
        </template>
        <template v-else>レスラクと連携を行うには、認証キーを登録してください。</template>
      </div>
    </template>
    <ResrakuSyncRegisterModal
      v-if="resrakuSyncRegisterModal"
      @close="resrakuSyncRegisterModal = false"
      @register="register"
    />
  </PropertySection>
</template>

<script>
import { mapState } from 'vuex'
import PropertySection from '@/components/molecules/PropertySection'
import ResrakuSyncRegisterModal from '@/components/organisms/ResrakuSyncRegisterModal'
import Dialog from '@/components/molecules/ModalDialog'

export default {
  name: 'ResrakuSync',
  components: {
    PropertySection,
    ResrakuSyncRegisterModal,
  },
  props: {
    resrakuSyncStatus: { type: Number, required: true },
    daichoAuthKey: { type: String },
    savedResrakuAuthKey: { type: Boolean, required: true },
    hasError: { type: Boolean, required: true },
  },
  data() {
    return {
      resrakuSyncRegisterModal: false,
    }
  },
  computed: {
    ...mapState({
      gnaviAuthKey: state => state.resraku.auth.gnaviAuthKey,
    }),
    resrakuSyncStatusLabel() {
      switch (true) {
        case this.resrakuSyncStatus === -1:
          return '連携エラー'
        case this.resrakuSyncStatus === 1:
          return '事前設定中'
        case this.resrakuSyncStatus === 2:
          return '一時停止中'
        case this.resrakuSyncStatus === 3:
          return '連携中'
        case this.resrakuSyncStatus === 4:
          return '実卓連携中'
        default:
          return '未連携'
      }
    },
    buttonDisabled() {
      return (this.savedResrakuAuthKey && !this.resrakuSyncStatus) || this.hasError
    },
    buttonText() {
      if (this.savedResrakuAuthKey && !this.resrakuSyncStatus) return '認証キー登録済み'
      return this.resrakuSyncStatus > 0 ? '連携するテーブルの設定' : '認証キー登録'
    },
    hideButton() {
      return this.resrakuSyncStatus === 1 || this.resrakuSyncStatus === 2 || this.resrakuSyncStatus === 4
    },
  },
  methods: {
    onClick() {
      if (this.resrakuSyncStatus) {
        this.$router.push({ name: 'Resraku' })
      } else {
        this.resrakuSyncRegisterModal = true
      }
    },
    displayAuthKey() {
      Dialog.show({
        title: 'ぐるなび認証キー',
        message: `ぐるなび認証キー: ${this.daichoAuthKey}`,
        okText: '閉じる',
      })
    },
    async showDialog() {
      await Dialog.show({
        title: 'レスラクの認証キーを登録しました',
        message: `ぐるなび認証キー: ${this.gnaviAuthKey}`,
        okText: '閉じる',
      })
      this.confirmDialog()
    },
    async confirmDialog() {
      if (
        await Dialog.confirm({
          title: 'レスラクの認証キー',
          message: `ぐるなび認証キー: ${this.gnaviAuthKey}\n\n本当に閉じてよろしいですか？`,
          okText: '閉じる',
          cancelText: '戻る',
          caution: true,
        })
      ) {
        location.reload()
      } else {
        this.showDialog()
      }
    },
    async register({ authKey }) {
      this.resrakuSyncRegisterModal = false
      if (await this.$store.dispatch('resraku/auth/register', authKey)) {
        this.showDialog()
      }
    },
  },
}
</script>
